import { ICN, REP_REC} from "../../Data/typeDirs"
import { genId } from "../../utils"



export class ReportRecommendation{

  constructor(data = {}){
    this._id = data._id || genId()
    this._reports_v2 = data._reports_v2
    this._report_blocks = data._report_blocks
    this.created = data.created || Date.now()
    this.modified = data.modified
    this._createdBy = data._createdBy
    this._modifiedBy = data._modifiedBy
    this.type = ReportRecommendation.getTypeDir()
    this.content = data.content ||''
    this.report_icons = data[ICN] || []
    this.eul = data.eul || ''
    this.erl = data.erl || ''
    this.age = data.age || ''
    this.total_cost = data.total_cost || ''
    this.unit_type = data.unit_type || ''
    this.quantity = data.quantity || ''
    this.unit_cost = data.unit_cost || ''
  }

  static createDefaultReportNarrative(reportId, reportBlockId){
   
    return new ReportRecommendation({
      _reports_v2:reportId,
      _report_blocks:reportBlockId,
      
    })
  }

  static getTypeDir() { return REP_REC }
  static getIndices() { return '_id,_reports_v2,_report_blocks' }


}